import { Pagination, Navigation } from "swiper";

export const BASE_URL = process.env.STRAPE_BASE_URI || "";
export const SUPPORTED_CHAIN = Number(process.env.SUPPORTED_CHAIN) || "";
export const BLOCK_EXPLORER = process.env.CHAIN_SCAN_BASE_URL || "";
export const POLYGEN_STATIC_SITE_BASE_URL = process.env.POLYGEN_STATIC_SITE_BASE_URL || "";
export const AUTHENTICATION_URL = `Bearer ${process.env.STRAPE_API_ACCESS_TOKEN}` || "";
export const API_URL = process.env.THE_GRAPH_API_BASE_URL || "";
export const metaMaskExtensionInstallationLink = "https://metamask.app.link/dapp/window.location/"
export const PROJECT_STATUSES = {
    LIVE : "Live",
    COMPLETED : "Completed",
    UPCOMING : "Upcoming"
}
export const transactionType ={
    Buy : "SaleBuy",
    Refund : "SaleRefund",
}

export const PARTIAL_TIME_FORMAT = "DD/MM/YYYY - hh:mm A"

export const COMPLETE_TIME_FORMAT = "DD/MM/YYYY - hh:mm A"

export const MUMBAI_TESTNET_CHAIN_ID = 80001;

export const MUMBAI_TESTNET_HEX_CHAIN_ID = "0x13881";

export  const CAN_START_SOURCE = "0x050001000b00";

export const sliderOptions = {
    slidesPerView : 4,
    slidesPerGroup : 4,
    spaceBetween : 20,
    loop : false,
    navigation : true,
    modules: [Pagination, Navigation],
    pagination : {
        clickable: true,
    },
    breakPoint : {
        "0": {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
        },
        "600": {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        "1200": {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        "1500": {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
    }

}

export const sliderProject = {
    slidesPerView : 3,
    slidesPerGroup : 3,
    spaceBetween : 20,
    loop : false,
    navigation : true,
    modules: [Navigation],
    breakPoint : {
        "0": {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
        },
        "600": {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        "1200": {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
    }

}

export const sliderHomepage = {
    slidesPerView : 1,
    slidesPerGroup : 1,
    spaceBetween : 20,
    loop : false,
    modules: [Pagination],
    pagination : {
        clickable: true,
    },
}

export const ABSOLUTE_ZERO_REGEX = /[.,]0$/

export const wrongChainMessage = {
    80001:"Incorrect chain - please switch to the Mumbai network",
    137:"Incorrect chain - please switch to the Polygon network"
}
